import { render, staticRenderFns } from "./KQuestionRadioGroupView.vue?vue&type=template&id=ccbf235a&"
import script from "./KQuestionRadioGroupView.vue?vue&type=script&lang=js&"
export * from "./KQuestionRadioGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports